import { API_V1 } from "../config/main-axios";

class Ticket {
  createNewTicket(data)  {
    return API_V1.post("/api/v2/message/", data, {
      headers: {
        "Content-Type": "application/json",
      }
    })
  }
  getTicketList(data) {
    return API_V1.get("/api/v2/chatrooms/list/", {
      params: data
    })
  }
  getTicketDetailsById(id) {
    return API_V1.get(`/api/v2/chatrooms/${id}/`)
  }
  getChatroomMessage(id) {
    return API_V1.get(`/api/v2/chatrooms/tickets/${id}/`)
  }
  updateStatusChatroom(id, data) {
    return API_V1.patch(`/api/v2/chatrooms/${id}/`, data)
  }
  addTicket(data) {
    return API_V1.post("/api/v2/chatrooms/tickets/", data)
  }
}

export default new Ticket();
